import AvatarName from "./AvatarName";

export default AvatarName;
